import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { GenericContainerCard, SideSpace } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import RenderTeamWhenTwoTeamsInSpace from './RenderWrestlerBySpaceAndNumber/RenderTeam/RenderTeamWhenTwoTeamsInSpace';
import RenderWrestlerWhenTwoInSpace from './RenderWrestlerBySpaceAndNumber/RenderWrestlerWhenTwoInSpace';
import RenderTeamWhenThreeTeamsInSpace from './RenderWrestlerBySpaceAndNumber/RenderTeam/RenderTeamWhenThreeTeamsInSpace';
import CenterInfoFightRendering from '../UtilitiesMatchMobile/GenericRendering/CenterInfoFightRendering';
import RenderTeamWhenFourInSpace from './RenderWrestlerBySpaceAndNumber/RenderTeam/RenderTeamWhenFourInSpace';
import RenderWrestlerWhenThreeInSpace from './RenderWrestlerBySpaceAndNumber/RenderWrestlerWhenThreeInSpace';
import RenderingMatchWithConditionExtended from '../UtilitiesMatchMobile/RenderingMatchWithConditionExtended';
import { Match, WrestlerInMatch } from '../../../../types';

export const WrapperSideSpace = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

interface HandicapMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

interface WrestlerWithTeam extends WrestlerInMatch {
    team?: number;
}

const HandicapMatchRender: FC<HandicapMatchRenderProps> = ({ matchInfo, withWinner = false, isExpanded = false }) => {
    const team1 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 1);
    const team2 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 2);

    function renderTeam(team: WrestlerInMatch[], side: 'left' | 'right'): ReactElement | ReactElement[] {
        switch (team.length) {
            case 1:
                return <RenderWrestlerWhenTwoInSpace wrestler={team[0]} side={side} withWinner={withWinner} />
            case 2:
                return (
                        team.map((wrestler, index) => (
                            <RenderWrestlerWhenTwoInSpace wrestler={wrestler} side={side} key={index} withWinner={withWinner} />
                        ))
                )
            case 3:
                return (
                    <WrapperColumn className='wrapper-column'>

                        {team.map((wrestler, index) => (
                            <RenderWrestlerWhenThreeInSpace wrestler={wrestler} side={side} key={index} withWinner={withWinner} />
                        ))}

                    </WrapperColumn>
                )
            case 4:
                return <RenderTeamWhenFourInSpace team={team} side={side} withWinner={withWinner} />
            default:
                return (<></>)
        }
    }

    function renderGenericContainerCard() {
        return (
            <GenericContainerCard className='handicap-match-render'
            height={isExpanded ? '80%' : '100%'}
            >
                <SideSpace className='side-space'>
                    <WrapperSideSpace className='wrapper-side-space'>
                        {renderTeam(team1, 'left')}
                    </WrapperSideSpace>
                </SideSpace>

                <CenterInfoFightRendering matchInfo={matchInfo} typeMatch='Handicap' />

                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {renderTeam(team2, 'right')}
                    </WrapperSideSpace>

                </SideSpace>
            </GenericContainerCard>
        )
    }

    return (
        RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo })
    )
}

export default HandicapMatchRender;
